module.exports = __webpack_public_path__ + "static/resume_marvinholleman-e09e796e7e94bd1b5284989602bee4a9.pdf";